var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymptomchecker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H28.4C33.9229 0 38.4 4.47715 38.4 10V28C38.4 33.5228 33.9228 38 28.4 38H9.99999C4.47715 38 0 33.5228 0 28V10Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1667 24.8333C21.8486 24.8333 24.8333 21.8486 24.8333 18.1667C24.8333 14.4848 21.8486 11.5 18.1667 11.5C14.4848 11.5 11.5 14.4848 11.5 18.1667C11.5 21.8486 14.4848 24.8333 18.1667 24.8333Z",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26.5L22.875 22.875",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1667 15.6667V20.6667",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 18.1667H20.6667",
    stroke: "#004276",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomchecker);
export default __webpack_public_path__ + "static/media/symptom checker.e3ddad7dee648b3eb5539ae2cf0f1b96.svg";
export { ForwardRef as ReactComponent };